import React, { useMemo } from 'react';

import sum from 'lodash/sum';

import { useReviews } from 'scenes/Gallery/GalleryPage/Concepts/Reviews/data';

const ReviewsContext = React.createContext({
  data: [],
  isLoading: false,
});

export const ReviewsProvider = ({ children, conceptId }) => {
  const { data, isLoading } = useReviews(conceptId);
  const avgScore = useMemo(() => {
    if (!data?.length) {
      return 0;
    }
    return sum(data.map(({ mark }) => mark)) / data?.length;
  }, [data]);

  return (
    <ReviewsContext.Provider
      value={{
        isLoading,
        data,
        conceptId,
        avgScore,
      }}
    >
      {children}
    </ReviewsContext.Provider>
  );
};

export default ReviewsContext;
